import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";
import moment from "moment";

const MerchantEmployeeAddExpenseList = ({
  open,
  close,
  setLoading,
  rerun,
  expenseConfig,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [dataValues, setDataValues] = useState({ data: [], ready: false });

  const handleAddExpense = (values) => {
    const formdata = new FormData();
    formdata.append(
      "merchant_user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "final_expense_date",
      moment(new Date(values.expense_date)).format("YYYY-MM-DD")
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/create/expense", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Expense created successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handlePanelChange = async (id) => {
    setDataValues({ data: [], ready: false });
    try {
      var params = {
        expense_type_id: id,
      };
      const response = await axios.get(`user/merchant/get/expense-config-sub`, {
        params,
      });
      console.log("RESPONSE DATA: ", response.data);
      setDataValues({ data: response.data, ready: true });
    } catch (error) {
      console.error("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="Add Expense Type"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="create-expense-type"
        initialValues={{
          description: "",
        }}
        onFinish={handleAddExpense}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="expense_type"
            label="Expense Type"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              onChange={(e) => {
                handlePanelChange(e);
              }}
            >
              {expenseConfig.data.map((data, index) => (
                <Select.Option value={data.key} key={index}>
                  {data.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {dataValues.ready && dataValues.data.length > 0 && (
            <Form.Item
              name="expense_sub_type"
              label="Expense Sub"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select placeholder="Select" size="large">
                {dataValues.data.map((data, index) => (
                  <Select.Option value={data.id} key={index}>
                    {data.description}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>

          <Form.Item
            name="expense_date"
            label="Expense Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"YYYY-MM-DD"}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantEmployeeAddExpenseList;
